import events from "../calendar/events.json";
import {getHijriMonthDay} from './PersianDate';

export default interface IEvent {
	date: Date,
	title: string,
	isHoliday: boolean,
}

export function getEventsOf(origin: Date) {
	const date = new Date(origin.getTime());
	const hijriDate = new Date(origin.getTime());
	hijriDate.setDate(hijriDate.getDate() - 1);
	const {month, day} = getHijriMonthDay(hijriDate);
	const ghamariKey = `${month}/${day}`;
  //@ts-ignore
  const ghamari: IEvent[] = events.ghamari[ghamariKey]?.map((event: any) => { return { ...event, date: date } }) ?? [];
  // @ts-ignore
  const jalali: IEvent[] = events.jalali[date.toLocaleDateString('fa-IR', { month: '2-digit', day: '2-digit' }).replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))]?.map((event: any) => { return { ...event, date: date } }) ?? [];
  // @ts-ignore
  const gregorian: IEvent[] = events.gregorian[date.toLocaleDateString('en-SA', { month: '2-digit', day: '2-digit' })]?.map((event: any) => { return { ...event, date: date } }) ?? [];
  return [...ghamari, ...jalali, ...gregorian];
}
